var stateChange,
  stateChangeDoneTimeout,
  hasLoadedOnce,
  cleanupStateChange,
  pendingStateChange;
var debug = 2;

window.app.factory("animate-route-pending", [
  () => () => (pendingStateChange ? pendingStateChange.promise : undefined)
]);

window.app.run([
  "$rootScope",
  "$state",
  "$q",
  function(scope, $state, $q) {
    var parentStateRegExp = /^(?:(.*)\.)?[^.]*$/;
    var isLoaderStateRegExp = /-async$/i;

    cleanupStateChange = function() {
      if (document.body.classList.contains("initial-animate-route")) {
        setTimeout(function() {
          document.body.classList.remove("initial-animate-route");
        }, 500);
      }
      if (!stateChange) {
        if (pendingStateChange) {
          pendingStateChange.reject("noStateChange");
        }
        return;
      }

      if (!stateChange.enter && !stateChange.leave && !hasLoadedOnce) {
        hasLoadedOnce = true;
      }
      debug &&
        console.debug(
          "routeAnimate.onStateChangeDone",
          stateChange.type,
          stateChange.subtype || ""
        );
      stateChange.skipped.forEach(element => element.remove());
      stateChange = undefined;
      $state.next = undefined;
      if (pendingStateChange) {
        var complete = pendingStateChange;
        pendingStateChange = undefined;
        complete.resolve();
      }
    };

    scope.$on("$stateChangeStart", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams
    ) {
      if (stateChange && !isLoaderStateRegExp.test(stateChange.toState.name)) {
        return;
      }
      var toParent = parentStateRegExp.exec(toState.name);
      var fromParent = parentStateRegExp.exec(fromState.name);
      var firstLoad = !hasLoadedOnce;

      var type, subtype, enter, leave;
      var target;
      var reverse = false;
      if (firstLoad) {
        type = "load";
        enter = leave = "load";
      } else if (
        fromState.name === "" ||
        isLoaderStateRegExp.test(fromState.name)
      ) {
        type = "initial";
        enter = leave = "enter";
      } else if (toState.name === fromState.name) {
        type = "replace";
        enter = leave = "replace";
      } else if (toParent[1] && toParent[1] === fromParent[1]) {
        type = "sibling";
        target = $state.get(toParent[1]);
        enter = leave = "children";
        reverse = true;
      } else {
        enter = "enter";
        leave = "leave";
        var shared = sharedPrefix(toState.name, fromState.name);
        if (shared) {
          if (shared === toState.name) {
            type = "child";
            target = $state.get(
              shared + "." + fromState.name.replace(shared, "").split(".")[1]
            );
          } else if (shared === fromState.name) {
            type = "child";
            target = $state.get(
              shared + "." + toState.name.replace(shared, "").split(".")[1]
            );
          } else {
            type = "child-navigate";
          }
        } else {
          type = "navigate";
        }
      }

      target = target || (!reverse ? toState : fromState);
      if (type === "replace") {
        var idKey;
        for (idKey in fromParams) {
          var fromId = fromParams[idKey];
          var toId = toParams[idKey];
          if (toId > fromId) {
            subtype = "increment";
            break;
          } else if (toId < fromId) {
            subtype = "decrement";
            break;
          }
        }
        if (subtype === "increment" || subtype === "decrement") {
          if (!(idKey in toState.params)) {
            for (
              var parentName = toState.name;
              parentName !== "";
              parentName = parentName
                .split(".")
                .slice(0, -1)
                .join(".")
            ) {
              var t = $state.get(parentName);
              if (t && idKey in t.params) {
                target = t;
                break;
              }
            }
          }
        }
      }

      var opts = target.animation;
      if (!opts) {
        return;
      }
      if (typeof opts === "function") {
        opts = opts(scope, toState, toParams);
      }
      if (opts.reTarget && opts.reTarget(toState.name)) {
        target = toState;
        // debugger // eslint-disable-line
        opts = target.animation || {};
        if (!opts) {
          return;
        } else if (typeof opts === "function") {
          opts = opts(scope, toState, toParams);
        }
      }

      stateChange = {
        type: type,
        subtype: subtype,
        target: !reverse ? "to" : "from",
        opts: opts,
        enter: opts[subtype] || opts[enter],
        leave: opts[subtype] || opts[leave],
        targetStates: [target.name].concat(opts.with || []),
        skipped: [],
        toState: toState
      };
      if (type === "initial") {
        document.body.classList.add("initial-animate-route");
      }
      debug &&
        console.debug(
          "routeAnimate.onStateChangeStart",
          target.name,
          type,
          enter === leave ? enter : [enter, leave],
          stateChange.enter,
          stateChange.leave
        );

      fromParams = fromParams || {};
      toParams = toParams || {};
      $state.next = Object.assign(
        {
          $parent: $state.get(
            toState.name
              .split(".")
              .slice(0, -1)
              .join(".")
          )
        },
        toState
      );

      pendingStateChange = $q.defer();
    });
    scope.$on("$stateChangeError", onStateChangeDone);
    scope.$on("$stateChangeSuccess", onStateChangeDone);

    function onStateChangeDone(
      event,
      toState,
      toParams,
      fromState,
      fromParams,
      error
    ) {
      stateChangeDoneTimeout = setTimeout(function() {
        stateChangeDoneTimeout = undefined;
        if (!stateChange) {
          return;
        }

        if (stateChange.count === undefined) {
          cleanupStateChange();
        }
      }, 200);
    }
  }
]);

var animation = routeAnimation(function(isEnter) {
  if (stateChange && stateChange.opts) {
    var { target } = stateChange;
    var mode = (target === "to" ? isEnter : !isEnter) ? "enter" : "leave";
    var name = stateChange[mode];
    return name ? `${name}-${mode}` : `ng-${mode}`;
  }
  return isEnter ? "ng-enter" : "ng-leave";
});

function routeAnimation(eventSelector) {
  return [
    "$animateCss",
    "$state",
    "$stateParams",
    "$rootScope",
    "$timeout",
    "$q",
    function($animateCss, $state, $stateParams, scope, $timeout, $q) {
      return {
        enter: function(element, done, options) {
          const elStateName = preHook("enter", element, options);
          if (!elStateName) {
            element.removeClass("ng-animate");
            return;
          }
          var event = eventSelector(true);
          debug && console.debug("routeAnimate.enter", event); //, elState, $state.next.name, $state.current.name);
          return $animateCss(element, {
            event: event,
            delay: true,
            structural: true,
            applyClassesEarly: true,
            cleanupStyles: true,
            onDone: function() {
              postHook("enter", elStateName, options);
              done();
            }
          });
        },
        leave: function(element, done, options) {
          const elStateName = preHook("leave", element, options);
          if (!elStateName) {
            if (stateChange) {
              stateChange.skipped.push(element);
            } else {
              element.remove();
            }
            return;
          }

          var event = eventSelector(false);
          debug && console.debug("routeAnimate.leave", event);
          return $animateCss(element, {
            event: event,
            delay: true,
            structural: true,
            applyClassesEarly: true,
            cleanupStyles: true,
            onDone: function() {
              postHook("leave", elStateName, options);
              done();
            }
          });
        }
      };

      function preHook(action, element, options) {
        var elState;
        if (stateChange) {
          var elUiViewData = element.data("$uiView");
          if (!elUiViewData) {
            if (element.attr("ui-view") !== undefined) {
              debug > 1 &&
                console.log(
                  "ANIMATE.skip uninitialized class =",
                  element.attr("class")
                );
              return false;
            }
            elUiViewData = element.inheritedData("$uiView");
            if (!elUiViewData) {
              debug && console.warn("ANIMATE.skip unkown");
              return false;
            }
          }
          elState = elUiViewData.state.self;
          if (stateChange.targetStates.indexOf(elState.name) === -1) {
            debug > 1 && console.debug("ANIMATE.skip", elState.name);
            return false;
          }
        }

        if (stateChangeDoneTimeout) {
          clearTimeout(stateChangeDoneTimeout);
          stateChangeDoneTimeout = undefined;
          if (stateChange) {
            stateChange.count = 0;
          }
        }

        if (stateChange) {
          ++stateChange.count;
          debug > 1 &&
            stateChange.count == 1 &&
            console.debug(
              "ANIMATE.start state =",
              elState.name,
              ", action =",
              action,
              ", animation =",
              stateChange[action],
              ", el =",
              element.attr("class").replace(/ /g, ".")
            );
          return elState.name;
        } else {
          debug > 1 &&
            console.debug(
              "ANIMATE.skip.noStateChange",
              elState ? elState.name : "unknown"
            );
        }
        return false;
      }

      function postHook(action, elStateName, options) {
        if (!stateChange) {
          return;
        }

        debug > 1 &&
          stateChange.count == 1 &&
          console.debug("ANIMATE.end ", elStateName, stateChange[action]);
        if (--stateChange.count == 0) {
          if (!hasLoadedOnce) {
            hasLoadedOnce = true;
          }
          setTimeout(function() {
            cleanupStateChange();
          }, 0);
        }
      }
    }
  ];
}

window.app.animation(".animate-route", animation);

function sharedPrefix(a, b) {
  var L = Math.min(a.length, b.length);
  for (var i = 0; i < L && a.charAt(i) === b.charAt(i); i++);
  return a.substring(0, i);
}



// WEBPACK FOOTER //
// ./src/services/routeAnimate.js